<template>
  <div>
    <loader :loading="loading"/>
    <div v-if="!loading">
      <page-title :title="$t(preset.type).label">
        <div slot="header-left">
          <img :src="preset.from.logo" class="logo" alt="">
          <i class="i-arrow icon-arrow-right"></i>
          <img :src="preset.to.logo" class="logo" alt="">
        </div>
        <div class="btnGroup" slot="header-right">
          <button @click="changeStatus(false)" v-bind:class="{ 'is-active': !preset.active }" class="btn btn--info btn--outline">
            Inativo
          </button>
          <button @click="changeStatus(true)" v-bind:class="{ 'is-active': preset.active }" class="btn btn--info btn--outline">
            Ativo
          </button>
        </div>
      </page-title>

      <panel>
        <loader :loading="loadingAddItem"/>
        <component :is="typeComponentAddItem" ref="typeComponentAddItem" :preset="preset" v-on:loading="onChangeAddItem" v-on:addItemEnable="addItemEnable">
          <div class="l-col-2@md vertical-center">
            <button @click="addPresetItem" :disabled="!enabledAdd" class="hint hint--left btn btn--info" :data-label="`Adicionar configuração de ${$t(preset.type).label}.`">
              <i class="icon-plus"/>
            </button>
          </div>
        </component>
      </panel>

      <panel title="Predefinições cadastradas">
        <loader :loading="loadingItem"/>

        <component :is="typeComponentItem" ref="typeComponentItem" v-for="item in preset.items" :key="item" :preset="preset" v-on:loading="onChangeItem" :item="item">
          <button @click="showConfirm(item)" class="hint hint--left btn btn--danger" :data-label="`Remover configuração de ${$t(preset.type).label}.`">
            <i class="icon-bin"/>
          </button>
        </component>

        <div v-if="!preset.items.length" class="u-textCenter">
          Nenhuma predefinição cadastrada.
        </div>
      </panel>

      <remove-dialog v-model="removeItemFlag" v-on:option="removePresetItem"/>

    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { upperFirst, isObject, isArray } from 'lodash'
  import api from '@/api'
  import PageTitle from '@/components/template/PageTitle'
  import Loader from '@/components/template/Loader'
  import Panel from '@/components/template/Panel'
  import notifier from '@/notifier'
  import RemoveDialog from '@/components/presets/RemoveDialog'

  // Ecommerce Moovin > Marketplace Cnova
  import EcommerceMoovinMarketplaceCnovaCategorizationAddItem from '@/components/presets/ecommerce/moovin/marketplace/cnova/CategorizationAddItem'
  import EcommerceMoovinMarketplaceCnovaCategorizationItem from '@/components/presets/ecommerce/moovin/marketplace/cnova/CategorizationItem'
  import EcommerceMoovinMarketplaceCnovaColorAddItem from '@/components/presets/ecommerce/moovin/marketplace/cnova/ColorAddItem'
  import EcommerceMoovinMarketplaceCnovaColorItem from '@/components/presets/ecommerce/moovin/marketplace/cnova/ColorItem'

  // Ecommerce Moovin > Marketplace Colombo
  import EcommerceMoovinMarketplaceColomboCategorizationAddItem from '@/components/presets/ecommerce/moovin/marketplace/colombo/CategorizationAddItem'
  import EcommerceMoovinMarketplaceColomboCategorizationItem from '@/components/presets/ecommerce/moovin/marketplace/colombo/CategorizationItem'

  // Ecommerce Moovin > Marketplace Leroy
  import EcommerceMoovinMarketplaceLeroyCategorizationAddItem from '@/components/presets/ecommerce/moovin/marketplace/leroy/CategorizationAddItem'
  import EcommerceMoovinMarketplaceLeroyCategorizationItem from '@/components/presets/ecommerce/moovin/marketplace/leroy/CategorizationItem'

  // Ecommerce Moovin > Marketplace Mercado Livre
  import EcommerceMoovinMarketplaceMercadoLivreCategorizationAddItem from '@/components/presets/ecommerce/moovin/marketplace/mercadoLivre/CategorizationAddItem'
  import EcommerceMoovinMarketplaceMercadoLivreCategorizationItem from '@/components/presets/ecommerce/moovin/marketplace/mercadoLivre/CategorizationItem'
  import EcommerceMoovinMarketplaceMercadoLivreColorAddItem from '@/components/presets/ecommerce/moovin/marketplace/mercadoLivre/ColorAddItem'
  import EcommerceMoovinMarketplaceMercadoLivreColorItem from '@/components/presets/ecommerce/moovin/marketplace/mercadoLivre/ColorItem'

  // Ecommerce Moovin > Marketplace Netshoes
  import EcommerceMoovinMarketplaceNetshoesBrandAddItem from '@/components/presets/ecommerce/moovin/marketplace/netshoes/BrandAddItem'
  import EcommerceMoovinMarketplaceNetshoesBrandItem from '@/components/presets/ecommerce/moovin/marketplace/netshoes/BrandItem'
  import EcommerceMoovinMarketplaceNetshoesCategorizationAddItem from '@/components/presets/ecommerce/moovin/marketplace/netshoes/CategorizationAddItem'
  import EcommerceMoovinMarketplaceNetshoesCategorizationItem from '@/components/presets/ecommerce/moovin/marketplace/netshoes/CategorizationItem'
  import EcommerceMoovinMarketplaceNetshoesColorAddItem from '@/components/presets/ecommerce/moovin/marketplace/netshoes/ColorAddItem'
  import EcommerceMoovinMarketplaceNetshoesColorItem from '@/components/presets/ecommerce/moovin/marketplace/netshoes/ColorItem'
  import EcommerceMoovinMarketplaceNetshoesSizeAddItem from '@/components/presets/ecommerce/moovin/marketplace/netshoes/SizeAddItem'
  import EcommerceMoovinMarketplaceNetshoesSizeItem from '@/components/presets/ecommerce/moovin/marketplace/netshoes/SizeItem'

  // Ecommerce Moovin > Marketplace Shein
  import EcommerceMoovinMarketplaceSheinCategorizationAddItem from '@/components/presets/ecommerce/moovin/marketplace/shein/CategorizationAddItem'
  import EcommerceMoovinMarketplaceSheinCategorizationItem from '@/components/presets/ecommerce/moovin/marketplace/shein/CategorizationItem'

  // Ecommerce Moovin > Marketplace Zoom
  import EcommerceMoovinMarketplaceZoomCategorizationAddItem from '@/components/presets/ecommerce/moovin/marketplace/zoom/CategorizationAddItem'
  import EcommerceMoovinMarketplaceZoomCategorizationItem from '@/components/presets/ecommerce/moovin/marketplace/zoom/CategorizationItem'

  // Ecommerce Moovin > Marketplace Sicredi
  import EcommerceMoovinMarketplaceSicrediCategorizationAddItem from '@/components/presets/ecommerce/moovin/marketplace/sicredi/CategorizationAddItem'
  import EcommerceMoovinMarketplaceSicrediCategorizationItem from '@/components/presets/ecommerce/moovin/marketplace/sicredi/CategorizationItem'
  import EcommerceMoovinMarketplaceSicrediColorAddItem from '@/components/presets/ecommerce/moovin/marketplace/sicredi/ColorAddItem'
  import EcommerceMoovinMarketplaceSicrediColorItem from '@/components/presets/ecommerce/moovin/marketplace/sicredi/ColorItem'

  // Tool API > Marketplace Sicredi
  import ToolApiMarketplaceSicrediCategorizationAddItem from '@/components/presets/tool/api/marketplace/sicredi/CategorizationAddItem'
  import ToolApiMarketplaceSicrediCategorizationItem from '@/components/presets/tool/api/marketplace/sicredi/CategorizationItem'
  import ToolApiMarketplaceSicrediColorAddItem from '@/components/presets/tool/api/marketplace/sicredi/ColorAddItem'
  import ToolApiMarketplaceSicrediColorItem from '@/components/presets/tool/api/marketplace/sicredi/ColorItem'

  // Ecommerce Moovin > Marketplace MaisCorreios
  import EcommerceMoovinMarketplaceMaisCorreiosCategorizationAddItem from '@/components/presets/ecommerce/moovin/marketplace/maisCorreios/CategorizationAddItem'
  import EcommerceMoovinMarketplaceMaisCorreiosCategorizationItem from '@/components/presets/ecommerce/moovin/marketplace/maisCorreios/CategorizationItem'
  import EcommerceMoovinMarketplaceMaisCorreiosColorAddItem from '@/components/presets/ecommerce/moovin/marketplace/maisCorreios/ColorAddItem'
  import EcommerceMoovinMarketplaceMaisCorreiosColorItem from '@/components/presets/ecommerce/moovin/marketplace/maisCorreios/ColorItem'

  // Tool API > Marketplace MaisCorreios
  import ToolApiMarketplaceMaisCorreiosCategorizationAddItem from '@/components/presets/tool/api/marketplace/maisCorreios/CategorizationAddItem'
  import ToolApiMarketplaceMaisCorreiosCategorizationItem from '@/components/presets/tool/api/marketplace/maisCorreios/CategorizationItem'
  import ToolApiMarketplaceMaisCorreiosColorAddItem from '@/components/presets/tool/api/marketplace/maisCorreios/ColorAddItem'
  import ToolApiMarketplaceMaisCorreiosColorItem from '@/components/presets/tool/api/marketplace/maisCorreios/ColorItem'

  // Ecommerce Moovin > Marketplace GFG
  import EcommerceMoovinMarketplaceGfgCategorizationAddItem from '@/components/presets/ecommerce/moovin/marketplace/gfg/CategorizationAddItem'
  import EcommerceMoovinMarketplaceGfgCategorizationItem from '@/components/presets/ecommerce/moovin/marketplace/gfg/CategorizationItem'
  import EcommerceMoovinMarketplaceGfgBrandAddItem from '@/components/presets/ecommerce/moovin/marketplace/gfg/BrandAddItem'
  import EcommerceMoovinMarketplaceGfgBrandItem from '@/components/presets/ecommerce/moovin/marketplace/gfg/BrandItem'
  import EcommerceMoovinMarketplaceGfgColorAddItem from '@/components/presets/ecommerce/moovin/marketplace/gfg/ColorAddItem'
  import EcommerceMoovinMarketplaceGfgColorItem from '@/components/presets/ecommerce/moovin/marketplace/gfg/ColorItem'

  // Ecommerce Moovin > Marketplace Amazon
  import EcommerceMoovinMarketplaceAmazonCategorizationAddItem from '@/components/presets/ecommerce/moovin/marketplace/amazon/CategorizationAddItem'
  import EcommerceMoovinMarketplaceAmazonCategorizationItem from '@/components/presets/ecommerce/moovin/marketplace/amazon/CategorizationItem'
  import EcommerceMoovinMarketplaceAmazonColorAddItem from '@/components/presets/ecommerce/moovin/marketplace/amazon/ColorAddItem'
  import EcommerceMoovinMarketplaceAmazonColorItem from '@/components/presets/ecommerce/moovin/marketplace/amazon/ColorItem'
  import EcommerceMoovinMarketplaceAmazonSizeAddItem from '@/components/presets/ecommerce/moovin/marketplace/amazon/SizeAddItem'
  import EcommerceMoovinMarketplaceAmazonSizeItem from '@/components/presets/ecommerce/moovin/marketplace/amazon/SizeItem'

  // Ecommerce Moovin > Skyhub
  import EcommerceMoovinMarketplaceSkyhubAdditionAddItem from '@/components/presets/ecommerce/moovin/marketplace/skyhub/AdditionAddItem'
  import EcommerceMoovinMarketplaceSkyhubAdditionItem from '@/components/presets/ecommerce/moovin/marketplace/skyhub/AdditionItem'

  // Ecommerce Moovin > Shopee
  import EcommerceMoovinMarketplaceShopeeCategorizationAddItem from '@/components/presets/ecommerce/moovin/marketplace/shopee/CategorizationAddItem'
  import EcommerceMoovinMarketplaceShopeeCategorizationItem from '@/components/presets/ecommerce/moovin/marketplace/shopee/CategorizationItem'
  import EcommerceMoovinMarketplaceShopeeColorAddItem from '@/components/presets/ecommerce/moovin/marketplace/shopee/ColorAddItem'
  import EcommerceMoovinMarketplaceShopeeColorItem from '@/components/presets/ecommerce/moovin/marketplace/shopee/ColorItem'
  import EcommerceMoovinMarketplaceShopeeSizeAddItem from '@/components/presets/ecommerce/moovin/marketplace/shopee/SizeAddItem'
  import EcommerceMoovinMarketplaceShopeeSizeItem from '@/components/presets/ecommerce/moovin/marketplace/shopee/SizeItem'

  // Tool API > Marketplace Leroy
  import ToolApiMarketplaceLeroyCategorizationAddItem from '@/components/presets/tool/api/marketplace/leroy/CategorizationAddItem'
  import ToolApiMarketplaceLeroyCategorizationItem from '@/components/presets/tool/api/marketplace/leroy/CategorizationItem'

  // Tool API > Marketplace Cnova
  import ToolApiMarketplaceCnovaCategorizationAddItem from '@/components/presets/tool/api/marketplace/cnova/CategorizationAddItem'
  import ToolApiMarketplaceCnovaCategorizationItem from '@/components/presets/tool/api/marketplace/cnova/CategorizationItem'

  // Tool API > Marketplace Colombo
  import ToolApiMarketplaceColomboCategorizationAddItem from '@/components/presets/tool/api/marketplace/colombo/CategorizationAddItem'
  import ToolApiMarketplaceColomboCategorizationItem from '@/components/presets/tool/api/marketplace/colombo/CategorizationItem'

  // Tool API > Marketplace Zoom
  import ToolApiMarketplaceZoomCategorizationAddItem from '@/components/presets/tool/api/marketplace/zoom/CategorizationAddItem'
  import ToolApiMarketplaceZoomCategorizationItem from '@/components/presets/tool/api/marketplace/zoom/CategorizationItem'

  export default {
    data: () => ({
      loading: true,
      loadingAddItem: false,
      loadingItem: false,
      showConfirmDialog: false,
      saving: false,
      removeItemFlag: false,
      removeItem: null,
      hasInputNullable: false,
      enabledAdd: false
    }),
    props: {
      fromType: {
        type: String,
        required: true
      },
      fromIdentifier: {
        type: String,
        required: true
      },
      toType: {
        type: String,
        required: true
      },
      toIdentifier: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
    async mounted () {
      if (this.presetsTotal === 0) {
        await this.fetchPresets({ options: {} })
      }

      this.loading = false
    },
    methods: {
      ...mapActions('presets', [
        'fetchPresets'
      ]),
      isEnableAddButton () {
        const newItem = this.$refs.typeComponentAddItem.newItem

        this.hasInputNullable = false

        for (let i in Object.keys(newItem)) {
          this.isEnabledAddButtonRecursive(newItem, Object.keys(newItem)[i])
        }

        this.enabledAdd = !this.hasInputNullable
      },
      isEnabledAddButtonRecursive (item, key) {
        if (item[key] === null) {
          this.hasInputNullable = true
        }

        if (isObject(item[key])) {
          for (let i in Object.keys(item[key])) {
            this.isEnabledAddButtonRecursive(item[key], Object.keys(item[key])[i])
          }
        }

        if (isArray(item[key])) {
          for (let i = 0; i < item[key].length; i++) {
            this.isEnabledAddButtonRecursive(item[key], i)
          }
        }
      },
      async addPresetItem () {
        this.$refs.typeComponentAddItem.addPresetItem()

        const newItem = this.$refs.typeComponentAddItem.formatPreset()

        if (!this.$refs.typeComponentAddItem.alreadyExists) {
          await this.addPreset()

          for (let i in Object.keys(newItem)) {
            this.clearPresetItemRecursive(newItem, Object.keys(newItem)[i])
          }
        }

        if (this.$refs.typeComponentAddItem['clearPresetAddItem'] !== undefined) {
          this.$refs.typeComponentAddItem.clearPresetAddItem()
        }
      },
      clearPresetItemRecursive (item, key) {
        if (isArray(item[key])) {
          for (let i = 0; i < item[key].length; i++) {
            item[key][i] = null
            this.clearPresetItemRecursive(item[key], i)
          }
        } else if (isObject(item[key])) {
          for (let i in Object.keys(item[key])) {
            this.clearPresetItemRecursive(item[key], Object.keys(item[key])[i])
          }
        } else {
          item[key] = null
        }
      },
      async removePresetItem () {
        const removePresetItem = this.preset.items.find(preset => JSON.stringify(preset) === JSON.stringify(this.removeItem))

        const preset = {
          'from': {
            'type': this.fromType,
            'identifier': this.fromIdentifier
          },
          'to': {
            'type': this.toType,
            'identifier': this.toIdentifier
          },
          'type': this.preset.type,
          'item': removePresetItem
        }

        try {
          await api.deletePreset(preset)
          this.preset.items = this.preset.items.filter(preset => preset !== this.removeItem)
          notifier.success(`Predefinição removida com sucesso.`, 'Sucesso')
        } catch (error) {
          notifier.error(`Erro ao remover predefinição.`, 'Erro')
        }
      },
      onChangeAddItem (value) {
        this.loadingAddItem = value
      },
      async onChangeItem (value) {
        this.loadingItem = value

        if (!this.$refs.typeComponentItem.find(component => component.itemsNames && !component.doneFilling)) {
          this.loadingItem = false
        }
      },
      showConfirm (item) {
        this.removeItemFlag = true
        this.removeItem = item
      },
      async changeStatus (status) {
        if (this.preset.active === status) {
          return false
        }

        try {
          await api.updateStatusPreset({
            'from': {
              'type': this.preset.from.type,
              'identifier': this.preset.from.identifier
            },
            'to': {
              'type': this.preset.to.type,
              'identifier': this.preset.to.identifier
            },
            'type': this.preset.type,
            'active': status
          })

          this.preset.active = status

          notifier.success(`Status da predefinição alterado com sucesso.`, 'Sucesso')
        } catch (error) {
          notifier.error('Erro na alteração de status da predefinição.', 'Erro')
        }
      },
      async addPreset () {
        this.saving = true

        const preset = this.$refs.typeComponentAddItem.formatPreset()

        try {
          await api.addPreset(preset)
          notifier.success(`Predefinição salva com sucesso.`, 'Sucesso')
        } catch (error) {
          notifier.error(`Erro ao salvar predefinição.`, 'Erro')
        }

        this.saving = false
      },
      addItemEnable () {
        if (this.$refs['typeComponentAddItem']['isEnableAddButton']) {
          this.enabledAdd = this.$refs['typeComponentAddItem']['isEnableAddButton']()
        } else {
          this.isEnableAddButton()
        }
      }
    },
    computed: {
      ...mapFields({
        presetsTotal: 'presets.total',
        presets: 'presets.presets'
      }),
      ...mapGetters('presets', [
        'getPresetByFromToAndType'
      ]),
      preset () {
        return this.getPresetByFromToAndType(
          { type: this.fromType, identifier: this.fromIdentifier },
          { type: this.toType, identifier: this.toIdentifier },
          this.type
        )
      },
      typeComponentAddItem () {
        const from = upperFirst(this.fromType) + upperFirst(this.fromIdentifier)
        const to = upperFirst(this.toType) + upperFirst(this.toIdentifier)
        return `${from}${to}${upperFirst(this.type)}AddItem`
      },
      typeComponentItem () {
        const from = upperFirst(this.fromType) + upperFirst(this.fromIdentifier)
        const to = upperFirst(this.toType) + upperFirst(this.toIdentifier)
        return `${from}${to}${upperFirst(this.type)}Item`
      }
    },
    components: {
      PageTitle,
      Loader,
      Panel,
      RemoveDialog,
      EcommerceMoovinMarketplaceCnovaCategorizationAddItem,
      EcommerceMoovinMarketplaceCnovaCategorizationItem,
      EcommerceMoovinMarketplaceCnovaColorAddItem,
      EcommerceMoovinMarketplaceCnovaColorItem,
      EcommerceMoovinMarketplaceColomboCategorizationAddItem,
      EcommerceMoovinMarketplaceColomboCategorizationItem,
      EcommerceMoovinMarketplaceLeroyCategorizationAddItem,
      EcommerceMoovinMarketplaceLeroyCategorizationItem,
      EcommerceMoovinMarketplaceMercadoLivreCategorizationAddItem,
      EcommerceMoovinMarketplaceMercadoLivreCategorizationItem,
      EcommerceMoovinMarketplaceMercadoLivreColorAddItem,
      EcommerceMoovinMarketplaceMercadoLivreColorItem,
      EcommerceMoovinMarketplaceNetshoesCategorizationAddItem,
      EcommerceMoovinMarketplaceNetshoesCategorizationItem,
      EcommerceMoovinMarketplaceNetshoesColorAddItem,
      EcommerceMoovinMarketplaceNetshoesColorItem,
      EcommerceMoovinMarketplaceNetshoesBrandAddItem,
      EcommerceMoovinMarketplaceNetshoesBrandItem,
      EcommerceMoovinMarketplaceNetshoesSizeAddItem,
      EcommerceMoovinMarketplaceNetshoesSizeItem,
      EcommerceMoovinMarketplaceSheinCategorizationAddItem,
      EcommerceMoovinMarketplaceSheinCategorizationItem,
      EcommerceMoovinMarketplaceZoomCategorizationAddItem,
      EcommerceMoovinMarketplaceZoomCategorizationItem,
      EcommerceMoovinMarketplaceGfgCategorizationAddItem,
      EcommerceMoovinMarketplaceGfgCategorizationItem,
      EcommerceMoovinMarketplaceGfgBrandAddItem,
      EcommerceMoovinMarketplaceGfgBrandItem,
      EcommerceMoovinMarketplaceGfgColorAddItem,
      EcommerceMoovinMarketplaceGfgColorItem,
      EcommerceMoovinMarketplaceAmazonCategorizationAddItem,
      EcommerceMoovinMarketplaceAmazonCategorizationItem,
      EcommerceMoovinMarketplaceAmazonColorAddItem,
      EcommerceMoovinMarketplaceAmazonColorItem,
      EcommerceMoovinMarketplaceAmazonSizeAddItem,
      EcommerceMoovinMarketplaceAmazonSizeItem,
      EcommerceMoovinMarketplaceSkyhubAdditionAddItem,
      EcommerceMoovinMarketplaceSkyhubAdditionItem,
      EcommerceMoovinMarketplaceShopeeCategorizationAddItem,
      EcommerceMoovinMarketplaceShopeeCategorizationItem,
      EcommerceMoovinMarketplaceShopeeColorAddItem,
      EcommerceMoovinMarketplaceShopeeColorItem,
      EcommerceMoovinMarketplaceShopeeSizeAddItem,
      EcommerceMoovinMarketplaceShopeeSizeItem,
      EcommerceMoovinMarketplaceSicrediCategorizationItem,
      EcommerceMoovinMarketplaceSicrediCategorizationAddItem,
      EcommerceMoovinMarketplaceMaisCorreiosCategorizationItem,
      EcommerceMoovinMarketplaceMaisCorreiosCategorizationAddItem,
      ToolApiMarketplaceLeroyCategorizationAddItem,
      ToolApiMarketplaceLeroyCategorizationItem,
      ToolApiMarketplaceCnovaCategorizationAddItem,
      ToolApiMarketplaceCnovaCategorizationItem,
      ToolApiMarketplaceColomboCategorizationAddItem,
      ToolApiMarketplaceColomboCategorizationItem,
      ToolApiMarketplaceZoomCategorizationAddItem,
      ToolApiMarketplaceZoomCategorizationItem,
      ToolApiMarketplaceSicrediCategorizationItem,
      ToolApiMarketplaceSicrediCategorizationAddItem,
      ToolApiMarketplaceSicrediColorAddItem,
      ToolApiMarketplaceSicrediColorItem,
      EcommerceMoovinMarketplaceSicrediColorAddItem,
      EcommerceMoovinMarketplaceSicrediColorItem,
      ToolApiMarketplaceMaisCorreiosCategorizationItem,
      ToolApiMarketplaceMaisCorreiosCategorizationAddItem,
      ToolApiMarketplaceMaisCorreiosColorAddItem,
      ToolApiMarketplaceMaisCorreiosColorItem,
      EcommerceMoovinMarketplaceMaisCorreiosColorAddItem,
      EcommerceMoovinMarketplaceMaisCorreiosColorItem
    }
  }
</script>

<style lang="sass" scoped>
  .logo
    display: inline-block
    vertical-align: middle

  .i-arrow
    font-size: 20px
    margin: 0 20px 0 0
</style>



// WEBPACK FOOTER //
// Edit.vue?2663ef22